import useAxios from 'hooks/useAxios';

export const login = async (email, password) => {
  const api = useAxios();
  try {
    return await api.post('/auth/login', { email, password });
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getCurrentUser = async () => {
  const api = useAxios();
  try {
    return (await api.get('backoffice-user/me')).data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const logout = async () => {
  const api = useAxios();
  try {
    return await api.post('/auth/logout');
  } catch (err) {
    console.error(err);
    throw err;
  }
};
